/*
 * "Goes with" row tracking (sections/restore-cross-sell.liquid).
 *
 * Sends Microsoft Clarity custom events so the owner can count sessions that saw a row and
 * sessions that used one, per row:
 *   goes_with_seen          a row was at least half on screen (once per page)
 *   goes_with_seen_<row>    that row was seen (once per row per page)
 *   goes_with_click         a product in a row was clicked
 *   goes_with_click_<row>
 *   goes_with_add           a row's Add to cart button was used (cart page rows)
 *   goes_with_add_<row>
 *   goes_with_shop_all_<row>  the row's "Shop all" link was clicked
 * <row> is the rule's block id without "rule_" (ghi_wall, washer, vanity …) or "department"
 * for the fallback row. Every event also sets the Clarity tag goes_with_page (product or cart).
 * No customer details are sent. Clarity queues calls made before its script loads.
 */
(function () {
  if (window.goesWithTracking) return;
  window.goesWithTracking = true;

  window.clarity =
    window.clarity ||
    function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };

  const sent = new Set();
  function send(name, once) {
    if (once && sent.has(name)) return;
    sent.add(name);
    try {
      window.clarity('event', name);
    } catch (e) {}
  }

  function rowKey(row) {
    return (row.dataset.goesWithRow || 'unknown').replace(/[^a-z0-9_]/gi, '_').toLowerCase();
  }

  function tagPage(row) {
    try {
      window.clarity('set', 'goes_with_page', row.dataset.goesWithPage || 'other');
    } catch (e) {}
  }

  function watch(row) {
    if (row.dataset.goesWithWatched) return;
    row.dataset.goesWithWatched = 'true';
    const key = rowKey(row);

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            tagPage(row);
            send('goes_with_seen', true);
            send('goes_with_seen_' + key, true);
            observer.disconnect();
          });
        },
        { threshold: 0.5 }
      );
      observer.observe(row);
    }

    row.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link || !row.contains(link)) return;
      tagPage(row);
      if (link.closest('.restore-cross-sell__header')) {
        send('goes_with_shop_all_' + key);
      } else if (link.getAttribute('href').indexOf('/products/') !== -1) {
        send('goes_with_click');
        send('goes_with_click_' + key);
      }
    });

    row.addEventListener('submit', (event) => {
      if (!event.target.closest('form')) return;
      tagPage(row);
      send('goes_with_add');
      send('goes_with_add_' + key);
    });
  }

  function init() {
    document.querySelectorAll('[data-goes-with-row]').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // The cart page re-renders its sections after quantity changes; pick up new rows.
  document.addEventListener('shopify:section:load', init);
  if (window.subscribe && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => setTimeout(init, 500));
  }
})();
